import '../../../../Events.js'

/** @namespace UI.Widget.Forms.Render */
NS("UI.Widget.Forms.Render");

/**
 * @class
 * @extends UI.Widget.Forms
 */
UI.Widget.Forms.Render.Base = Class(Events, /** @lends UI.Widget.Forms.Render.Base */ {
    //template: null,
    formTemplate: "UI/Widget/Form/FormForm",
    buttonTemplate: "UI/Widget/Render/Partial/FormControls",
    overlayTemplate: "UI/Widget/Render/Overlay",

    $overlay: null,

    baseClass: null,
    hasOverlay: true,
    styles: [],

    titleField: 'item.name', // какое поле выводить в качестве тайтла
    subtitleField: null, // и подзаголовка

    showEditControls: true,

    formButtons: [{
        name: 'save',
        title: "Сохранить",
        onClick: 'onSaveClick',
        hidden: false,
        float: "left",
        access: wgt => !_.isFunction(wgt.canSave) || wgt.canSave()
    }, {
        name: 'cancel',
        title: "Отмена",
        onClick: 'onCancelClick',
        hidden: false,
        float: "left",
    }],
    addClass: function() {

    },
    overlay: function(hasOverlay) {
        if (hasOverlay !== undefined) {
            this.hasOverlay = hasOverlay;
            return this;
        } else {
            return this.hasOverlay;
        }
    },
    /**
     * Настраивает форму и оборачивает ее в контейнер
     * Метод надо вызывать в методе render, если используется вместе с виджетом UI.Widget.Base
     *
     * @abstract
     * @returns {UI.Widget.Forms.Render.Base}
     */
    renderContainer: function() {},
    /**
     * Отрисовывает подложку модальной формы
     * @returns {UI.Widget.Forms.Render.Base}
     */
    renderOverlay: function() {
        var self = this;
        if (this.hasOverlay && !this.$overlay) {
            this.$overlay = UI.Template.$render(this.overlayTemplate).insertBefore(this.$element);
            this.$overlay.click(function() {
                self.onCancelClick();
            });
            this.$overlay.css('z-index', this.$element.css('z-index'));
            this.on("destroy", function() {
                this.$overlay.remove();
            });

        }
        return this;
    },
    getButtons: function () {
        return this.formButtons.filter(btn => !_.isFunction(btn.access) || btn.access(this));
    },
    renderButtons: function() {
        this.$name("form-controls").empty().append(
            UI.Template.$render(this.buttonTemplate, {
                widget: this
            }).insertBefore(this.$element)
        );

        return this;
    },
    getTitle() {
        return _.get(this, this.titleField) || '';
    }
});
